import update from 'immutability-helper';
import * as actionTypes from '../constants/actionTypes';
var initialState = {
    isRequired: null,
    isValid: null,
    value: '',
    isBeingVerified: false,
};
export default function password(state, action) {
    if (state === void 0) { state = initialState; }
    if (action.type === actionTypes.PASSWORD_REQUIRED) {
        return update(state, { isRequired: { $set: true } });
    }
    if (action.type === actionTypes.VERIFY_PASSWORD) {
        return update(state, { isBeingVerified: { $set: true } });
    }
    if (action.type === actionTypes.PASSWORD_INVALID) {
        return update(state, {
            isValid: { $set: false },
            isBeingVerified: { $set: false },
        });
    }
    if (action.type === actionTypes.PASSWORD_VALID) {
        return update(state, {
            isValid: { $set: true },
            isBeingVerified: { $set: false },
        });
    }
    return state;
}
